// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__p-b4Q","consentsList":"PatientConsents_consentsList__iFqfc","consentsListEmpty":"PatientConsents_consentsListEmpty__A9nWJ"};